import useApiRequest from "../common/useApiRequest";
import { useQuery } from "@tanstack/react-query";
import { User } from "@shared/types/user";
import Cookies from "js-cookie";

type UseUserResult = {
  user: User | undefined;
  error: Error | null;
  isLoading: boolean;
  isFetching: boolean;
  isError: boolean;
  refetchUser: () => void;
};

/**
 * Hook to fetch current user data.
 * User data is cached and refetched based on enabled state and access token.
 */
export const useUser = (enabled: boolean): UseUserResult => {
  const { GET } = useApiRequest();
  const accessToken = Cookies.get("access_token");

  const { data, error, isLoading, isFetching, isError, refetch } = useQuery<
    User,
    Error
  >({
    queryKey: ["user"],
    queryFn: async () => {
      const userData: User = await GET("/api/user/me");
      return userData;
    },
    enabled: enabled && !!accessToken,
  });

  return {
    user: data,
    error: error ?? null,
    isLoading,
    isFetching,
    isError,
    refetchUser: refetch,
  } satisfies UseUserResult;
};
